
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoCNRTVDtDialog extends Serenity.Extensions.GridEditorDialog<PoCNRTVDtRow> {
        protected getFormKey() { return PoCNRTVDtForm.formKey; }
        // protected getIdProperty() { return PoCNRTVDtRow.idProperty; }
        protected getLocalTextPrefix() { return PoCNRTVDtRow.localTextPrefix; }
        protected getNameProperty() { return PoCNRTVDtRow.nameProperty; }
        // protected getService() { return PoCNRTVDtService.baseUrl; }
        // protected getDeletePermission() { return PoCNRTVDtRow.deletePermission; }
        // protected getInsertPermission() { return PoCNRTVDtRow.insertPermission; }
        // protected getUpdatePermission() { return PoCNRTVDtRow.updatePermission; }

        protected form = new PoCNRTVDtForm(this.idPrefix);
        public qnNo: number;
        public purprice: number;
        public StkUnitT: string;
        public purratio: number;
        public purpz: number;
        public lsprun: number;
        private qty: number;
        public purunit: string;

        constructor() {
            super();
            this.form = new PoCNRTVDtForm(this.idPrefix);

            // let q = Q.tryFirst(PoCreditNoteDtRow.getLookup().items, x => x.Id == this.form.PiLineId.value)
            //     this.purunit = q.PurUnit
            //     this.purratio = q.PurUnitRatio
            //     this.purprice = q.PurUnitPrice
            //     this.qty = q.StkQty - q.QtyUse

            this.form.DiscText.changeSelect2(e => {
                var discStr = this.form.DiscText.value;
                if (discStr) {
                    //20%,5%,200
                    let a = discStr.split(",")
                    console.log(a)
                    var totalAmt = this.form.BeforeDiscAmt.value;
                    var discamt = 0
                    //var net = 0

                    for (var po of a) {

                        if (po.includes("%")) {
                            let a = po.replace("%", "");
                            let b = Number(a);
                            console.log(b)
                            let amt = totalAmt * b / 100
                            discamt = discamt + amt;
                            totalAmt = totalAmt - amt;
                        } else {
                            let x = Number(po)
                            discamt = discamt + x
                            totalAmt = totalAmt - x;
                        }

                    }

                    console.log("Lasttotal:" + totalAmt)
                    console.log("DiscAmt:" + discamt)

                    this.form.DiscAmt.value = discamt
                    this.form.ItemAmt.value = totalAmt
                    this.form.ItemNetAmt.value = totalAmt - (this.form.AlocalteDiscAmt.value || 0)

                    // const disAmt =  (totalAmt * discStr) / 100;
                    // this.form.DiscAmt.value = disAmt;
                    //this.form.NetAmt.value = totalAmt - disAmt;
                    this.CalVat();

                }
            });
            this.form.DiscText.addValidationRule(this.uniqueName, e => {
                var totalAmt = this.form.BeforeDiscAmt.value;
                var disAmt = this.form.DiscAmt.value;
                if (totalAmt != null && disAmt != null && disAmt > 0 && disAmt > totalAmt) {
                    return "Discount can't be higher than total amount!";
                }
            });


            this.form.UnitChange.change(e => {

                var change = this.form.UnitChange.value
                var skucode: string = this.form.SkuCode.value;
                var w = this.form.PiLineId.value;
                if(w > 0){
                let q = Q.tryFirst(PoCreditNoteDtRow.getLookup().items, x => x.Id == w)
                this.purunit = q.PurUnit
                this.purratio = q.PurUnitRatio
                this.purprice = q.PurUnitPrice
                this.qty = q.StkQty - q.QtyUse
                if (change == "1") {
                    if (q.UnitChange == 1) {
                       
                        this.form.PurUnitPrice.value = q.PurUnitPrice;
                        this.form.PurUnit.value = q.PurUnit; 
                        this.form.Qty.value = this.qty/ this.purratio                              
    
                                                                         

                        this.Calamt();
                    } else {
                        Q.warning("รับเข้า ด้วยหน่วยสต๊อก ไม่สามารถคืนเป็นหน่อยซื้อได้")
                        this.form.UnitChange.value = "0";
                    }
                }
                if (change == "0") {
                                           
                        this.form.PurUnitPrice.value = q.PurUnitPrice/this.purratio;
                        this.form.PurUnit.value = Product.CsSkuRow.getLookup().itemById[skucode].StkUnit;
                        this.form.Qty.value = this.qty                    

                        this.Calamt();
                   
                }

            }

            });

            this.form.Qty.changeSelect2(e => {
                var skucode = Q.toId(this.form.Qty.value);
                if (skucode != null) {

                    var PrRef: string = this.form.PiRefDocNo.value

                    if (!Q.isEmptyOrNull(PrRef)) {
                        var line = this.form.PiLineId.value
                        let pr = Q.first(Purchase.PoPurInvoiceDtRow.getLookup().items, x => x.Id == line && x.SysDocNo == PrRef);
                        let lessqty = pr.StkQty - pr.QtyUse
                        if (lessqty < (this.form.Qty.value * this.form.PurUnitRatio.value)) {
                            Q.warning("จำนวนคงเหลือ ไม่เพียงพอ")
                            this.form.Qty.value = lessqty /this.form.PurUnitRatio.value
                        }

                    }

                    this.Calamt();
                }
            });

            this.form.PurUnitPrice.changeSelect2(e => {
                var skucode = Q.toId(this.form.PurUnitPrice.value);
                if (skucode != null) {

                    this.Calamt();

                }
            });

            this.form.BeforeDiscAmt.changeSelect2(e => {
                var skucode = Q.toId(this.form.BeforeDiscAmt.value);
                if (skucode != null) {

                    this.Calamt();

                }
            });

        }

        
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            buttons.push(
                {

                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **
                    },
                }
            );

            return buttons;
        }

      
        protected beforeLoadEntity() {
            let self = this;



            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
            let f = this.form;
            // if (f.SkuCode.value != null) {
            /* let self = this;*/

            // self.toolbar.findButton("button-skucode").addClass("skuStockStatus");
            // self.toolbar.findButton('button-newdelete').addClass("skuEssential");
            // }

        }

        private Calamt() {


            this.form.BeforeDiscAmt.value = (this.form.PurUnitPrice.value) * (this.form.Qty.value);

            this.form.ItemAmt.value = (this.form.BeforeDiscAmt.value - this.form.DiscAmt.value)

            this.form.ItemNetAmt.value = this.form.ItemAmt.value - (this.form.AlocalteDiscAmt.value || 0);
            // console.log(this.form.DiscAmt.value + "dis");
            this.CalVat();


        }


        private CalVat() {


            const Totalafterdis = this.form.ItemNetAmt.value

            var vatRate = this.form.VatRate.value

            var salev = this.form.SalesVatTypes.value
            console.log("vattype:"+salev)
            if(salev == "E"){
            this.form.ItemVatAmt.value = (Totalafterdis* (vatRate/100));
            this.form.ItemExVatAmt.value = Totalafterdis
            this.form.ItemNetCostValue.value = Totalafterdis+this.form.ItemVatAmt.value+this.form.ItemExciseTaxAmt.value
            }    //vat นอก       
            else {
            this.form.ItemVatAmt.value = (Totalafterdis * vatRate) / (vatRate + 100);
            this.form.ItemExVatAmt.value = Totalafterdis - this.form.ItemVatAmt.value
            this.form.ItemNetCostValue.value = Totalafterdis +this.form.ItemExciseTaxAmt.value
        }

        }
       

    }
}